import axios from "axios";
import apiUrl from "./api";

async function getUserpaymentList(pageNo = 0, key = "", filter) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/pool/retain-join-requests?pageNumber=${pageNo}&searchKey=${key}&status=${filter}`, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error;
    }
}

async function updatePoolJoinRequest(data) {
    const token = window.localStorage.getItem('token');
    const userData = JSON.parse(window.localStorage.getItem('userData'));

    try {
        const response = await axios.put(`${apiUrl}secure/pool/update-join-request`, data, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                "X-User-Id": userData.userId,
                'Authorization': `Bearer ${token}`,
            }
        });

        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error;
    }
}
export { getUserpaymentList,updatePoolJoinRequest };